import React, { useEffect, useRef } from "react";

function useDidMountEffect(func: any, deps: any) {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      //@ts-ignore
      didMount.current = true;
    }
  }, deps);
}

export default useDidMountEffect;
